function attachInsideTheModuleModal () {
  return {
    restrict: 'E',
    templateUrl: '/repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.html?$$REVISION$$'
  }
}
export { attachInsideTheModuleModal }
